import { EventEmitter, Injectable, inject } from '@angular/core';
import { Firestore, QuerySnapshot, collection, doc, getDocs, onSnapshot, query, setDoc, where } from '@angular/fire/firestore';
import { Observable, combineLatest, from, map, shareReplay, switchMap } from 'rxjs';
import { PaymentTypes, stripeProductCollectionAccumulator } from '../utils/stripe.utils';
import { httpsCallable } from 'firebase/functions';
import { Auth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { generateUUID } from '../editor/utils/store.utils';
import { MessageService } from 'primeng/api';
import { FirebaseFunctionService } from './firebase-function.service';

@Injectable({
    providedIn: 'root'
})
export class StripeHandlerService {
    private auth = inject(Auth)
    private firestore = inject(Firestore)
    private router = inject(Router)
    private functions = inject(FirebaseFunctionService)
    private messageSerivce = inject(MessageService)

    private customerCollection = collection(this.firestore, "customers")
    private productsCollection = collection(this.firestore, "products")


    public creditProducts$ = stripeProductCollectionAccumulator(from(
        getDocs(
            query(
                this.productsCollection,
                where("active", "==", true), where("metadata.itemType", "==", "credits")
            )
        ))
    ).pipe(
      shareReplay(1)
    )


    public subscriptionProducts$ = stripeProductCollectionAccumulator(from(
        getDocs(
            query(
                this.productsCollection,
                where("active", "==", true), where("metadata.itemType", "==", "subscription")
            )
        ))
        ).pipe(
      shareReplay(1)
    )

    public enterpriseProducts$ = stripeProductCollectionAccumulator(from(
        getDocs(
            query(
                this.productsCollection,
                where("active", "==", true), where("metadata.itemType", "==", "enterprise")
            )
        ))
        ).pipe(
      shareReplay(1)
    )

    public createCheckoutSession = (priceId: string, type: PaymentTypes, quantity?: number): void => {
        if (!this.auth.currentUser) {
            this.router.navigate(["login"])
            return
        }

        const docRef = `customers/${this.auth.currentUser.uid}/checkout_sessions/${generateUUID()}`
        setDoc(doc(this.firestore, docRef), {
            mode: type,
            price: priceId,
            quantity: quantity ?? 1,
            allow_promotion_codes: true,
            success_url: window.location.origin + "/my-renders/purchase-success",
            cancel_url: window.location.origin + "/market",
        }).then(_ =>{
                onSnapshot(doc(this.firestore, docRef),(snapshot) => {
                    const data = snapshot.data()
                    if (!data) {
                        this.messageSerivce.add({severity: 'error', summary: 'Payment Error', detail: `Something is wrong with our payment provider. Please try again later`});
                        return
                    }
                    if (data['error']) {
                        this.messageSerivce.add({severity: 'error', summary: 'An Error Occurred', detail: data['error'].message});
                        return
                    }
                    if (data['url']) {
                        window.location.assign(data['url']);
                    }
                })
            })
    }

    public createPortalSession =  async (): Promise<void> => {
      const { data } = await httpsCallable<any,{url: string}>(this.functions.functions, 'ext-firestore-stripe-payments-createPortalLink')(
        {
          returnUrl: window.location.origin,
          locale: "auto", // Optional, defaults to "auto"
        }
      )
      window.location.assign(data.url);
    }


  constructor() {
    this.creditProducts$.subscribe();
    this.subscriptionProducts$.subscribe();
  }
}
